import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GetTasksResponse } from '@/models/task'
import api from '@/shared/api'
import { ENDPOINTS } from '@/shared/constants'

interface TasksState {
  pendingTotal: number
}

const initialState: TasksState = {
  pendingTotal: 0,
}

export const fetchPendingTasksTotal = createAsyncThunk<number>(
  'tasks/fetchPendingTasksTotal',
  async () => {
    const response = await api.get(ENDPOINTS.TASKS.GET.ALL)
    const data = response.data as GetTasksResponse

    return data.totals.pending
  }
)

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setPendingTasksTotal(state, action: PayloadAction<number>) {
      state.pendingTotal = action.payload
    },
    incrementPendingTasksTotal(state) {
      state.pendingTotal += 1
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPendingTasksTotal.fulfilled, (state, action) => {
      state.pendingTotal = action.payload
    })
  },
})

export const { incrementPendingTasksTotal, setPendingTasksTotal } =
  tasksSlice.actions
export default tasksSlice.reducer
